<template>
  <div class="my-upload">
    <el-upload
      :auto-upload="false"
      :drag="true"
      action=""
      :on-change="readFile"
      :on-exceed="handleExceed"
      ref="upload"
      :show-file-list="false"
      accept=".xls,.txt,.csv,.xlsx"
      :before-upload="beforeUpload"
    >
      <el-button type="primary">{{$t('messages.home.tip58')}}</el-button>
    </el-upload>
  </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
  name: 'ExcelParse',
  data() {
    return {}
  },
  methods: {
    readExcelFile(file) {
      const reader = new FileReader()
      reader.onload = event => {
        try {
          const binaryFile = event.target.result
          const workBook = XLSX.read(binaryFile, { type: 'binary' })
          // const data = XLSX.utils.sheet_to_json(workBook.Sheets.Sheet1)
          const data = XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]])
          if (data.length > 0) {
            this.$emit('parseExcel', data)
          } else {
            this.$message.warning(this.$t('messages.tipError.limitErr9'))
          }
        } catch (e) {
          this.$message.warning(this.$t('messages.tipError.limitErr10'))
        }
      }
      reader.readAsBinaryString(file.raw)
    },
    readTxtFile(file) {
      const reader = new FileReader()
      reader.onload = () => {
        try {
          let result = reader.result
          if (result) {
            let reg = /\r\n|\r|\n/
            let arr = result.split(reg)
            let data = arr
              .map(i => {
                return {
                  keywords: i,
                }
              })
              .filter(row => row.keywords !== '')
            this.$emit('parseExcel', data)
          } else {
            this.$message.warning(this.$t('messages.tipError.limitErr9'))
          }
        } catch (e) {
          this.$message.warning(this.$t('messages.tipError.limitErr10'))
        }
      }
      reader.readAsText(file.raw, 'utf-8')
    },
    readCsvFile(file) {
      const reader = new FileReader()
      reader.onload = event => {
        try {
          let result = reader.result
          if (result) {
            let reg = /\r\n|\r|\n/
            let arr = result.split(reg)
            let data = arr
              .map(i => {
                return {
                  keywords: i.replace(/"|”|“/g, ''),
                }
              })
              .filter(row => row.keywords !== '')
            if (data[0] && data[0].keywords === 'keywords') {
              data.splice(0, 1)
            }
            this.$emit('parseExcel', data)
          } else {
            this.$message.warning(this.$t('messages.tipError.limitErr9'))
          }
        } catch (e) {
          this.$message.warning(this.$t('messages.tipError.limitErr10'))
        }
      }
      reader.readAsText(file.raw, 'utf-8')
    },
    readFile(file) {
      if (file.size > 3 * 1024 * 1024) {
        this.$message.error(this.$t('messages.tipError.limitErr6'))
        this.files.splice(1, 1)
        return
      }
      var testmsg = this.getExtension(file)
      if (testmsg === 'xls' || testmsg === 'xlsx') {
        this.readExcelFile(file)
      }
      if (testmsg === 'txt') {
        this.readTxtFile(file)
      }
      if (testmsg === 'csv') {
        this.readCsvFile(file)
      }
    },
    handleExceed() {
      this.$message.error(this.$t('messages.tipError.limitErr7'))
    },
    getExtension(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      return testmsg
    },
    beforeUpload(file) {
      var testmsg = this.getExtension(file)
      const extension = testmsg === 'xls' || testmsg === 'xlsx' || testmsg === 'txt' || testmsg === 'csv'
      if (!extension) {
        this.$message.warning(this.$t('messages.tipError.limitErr8'))
      }
      return extension
    },
  },
}
</script>

<style lang="scss">
.my-upload {
  .el-upload-dragger {
    width: auto !important;
    height: auto !important;
    border: none !important;
  }
}
</style>
